"use client";

import { useRouter } from "next/router";
import React from "react";
import { useLargeTitleVisible } from "apollo/components/mobile/large-title";
import { PushedHeader } from "apollo/components/mobile/pushed-screen";
import { inAppTrail } from "apollo/lib/in-app-history";

/**
 * The app header on a page reached from More: Back (to where the user came
 * from, or More on a deep link) and the page's name, which waits off screen
 * while the page's own large title shows.
 */
export const MoreStackBar = ({ title }: { title: string }) => {
  const router = useRouter();
  const titleHidden = useLargeTitleVisible();
  return (
    <PushedHeader
      title={title}
      titleHidden={titleHidden}
      backLabel="Back"
      onBack={() =>
        inAppTrail().length ? router.back() : router.replace("/more")
      }
      className="h-12 bg-background"
    />
  );
};
